import {Injectable} from '@angular/core';
import {ErrorMessage} from '../models/error-message/ErrorMessage';
import {FormGroup} from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class TooltipService {
  private requiredState = false;
  private existsState = false;
  private invalidState = false;
  private doesntExistsState = false;
  private alreadyUsed = false;
  private individualOwnerType = false;
  private organizationOwnerType = false;
  private formGroup: FormGroup;

  constructor(formGroup: FormGroup) {
    this.formGroup = formGroup;
  }

  inputValidation(inputName: string, required: string, alreadyExists: string, invalid: string) {
    this.requiredState = (this.formGroup.get(inputName)?.invalid && (this.formGroup.get(inputName)?.dirty
        || this.formGroup.get(inputName)?.touched))
      && (this.formGroup.get(inputName)?.value === undefined
        || this.formGroup.get(inputName)?.value === ''
        || this.formGroup.get(inputName)?.value === null);
    this.existsState = this.formGroup.get(inputName)?.errors?.exists !== undefined;
    this.invalidState = (this.formGroup.get(inputName)?.errors?.minlength
      || this.formGroup.get(inputName)?.errors?.maxlength
      || this.formGroup.get(inputName)?.errors?.max
      || this.formGroup.get(inputName)?.errors?.pattern) !== undefined;
    return [
      new ErrorMessage(required, this.requiredState),
      new ErrorMessage(alreadyExists, this.existsState),
      new ErrorMessage(invalid, this.invalidState)
    ];
  }

  getState(inputName: string) {
    return (this.formGroup.get(inputName)?.invalid && (this.formGroup.get(inputName)?.dirty
        || this.formGroup.get(inputName)?.touched))
      && (this.formGroup.get(inputName)?.value === undefined
        || this.formGroup.get(inputName)?.value === ''
        || this.formGroup.get(inputName)?.value === null)
      || this.formGroup.get(inputName)?.errors?.emailUsed
      || this.formGroup.get(inputName)?.errors?.exists !== undefined
      || (this.formGroup.get(inputName)?.errors?.minlength
        || this.formGroup.get(inputName)?.errors?.max
        || this.formGroup.get(inputName)?.errors?.maxlength
        || this.formGroup.get(inputName)?.errors?.doesntExist
        || this.formGroup.get(inputName)?.errors?.pattern) !== undefined
      || this.formGroup.get(inputName)?.errors?.individualOwnerType !== undefined
      || this.formGroup.get(inputName)?.errors?.organizationOwnerType !== undefined;
  }

  emailValidation(inputName: string, required: string, alreadyExists: string, invalid: string,
                  doesntExists: string, alreadyUsed: string) {
    this.requiredState = (this.formGroup.get(inputName)?.invalid && (this.formGroup.get(inputName)?.dirty
        || this.formGroup.get(inputName)?.touched))
      && (this.formGroup.get(inputName)?.value === undefined
        || this.formGroup.get(inputName)?.value === ''
        || this.formGroup.get(inputName)?.value === null);
    this.existsState = this.formGroup.get(inputName)?.errors?.exists !== undefined;
    this.invalidState = (this.formGroup.get(inputName)?.errors?.minlength
      || this.formGroup.get(inputName)?.errors?.maxlength
      || this.formGroup.get(inputName)?.errors?.pattern) !== undefined;
    this.doesntExistsState = this.formGroup.get(inputName)?.errors?.doesntExist !== undefined;
    this.alreadyUsed = this.formGroup.get(inputName)?.errors?.emailUsed !== undefined;
    return [
      new ErrorMessage(required, this.requiredState),
      new ErrorMessage(alreadyExists, this.existsState),
      new ErrorMessage(invalid, this.invalidState),
      new ErrorMessage(doesntExists, this.doesntExistsState),
      new ErrorMessage(alreadyUsed, this.alreadyUsed)
    ];
  }

  ownerEmailValidation(inputName: string, required: string, alreadyExists: string, invalid: string,
                       doesntExists: string, alreadyUsed: string, individualOwnerType: string, organizationOwnerType: string) {
    this.requiredState = (this.formGroup.get(inputName)?.invalid && (this.formGroup.get(inputName)?.dirty
        || this.formGroup.get(inputName)?.touched))
      && (this.formGroup.get(inputName)?.value === undefined
        || this.formGroup.get(inputName)?.value === ''
        || this.formGroup.get(inputName)?.value === null);
    this.existsState = this.formGroup.get(inputName)?.errors?.['exists'] !== undefined;
    this.invalidState = (this.formGroup.get(inputName)?.errors?.['minlength']
      || this.formGroup.get(inputName)?.errors?.['maxlength']
      || this.formGroup.get(inputName)?.errors?.['pattern']) !== undefined;
    this.doesntExistsState = this.formGroup.get(inputName)?.errors?.['doesntExist'] !== undefined;
    this.alreadyUsed = this.formGroup.get(inputName)?.errors?.['emailUsed'] !== undefined;
    this.individualOwnerType = this.formGroup.get(inputName)?.errors?.['individualOwnerType'] !== undefined;
    this.organizationOwnerType = this.formGroup.get(inputName)?.errors?.['organizationOwnerType'] !== undefined;

    return [
      new ErrorMessage(required, this.requiredState),
      new ErrorMessage(alreadyExists, this.existsState),
      new ErrorMessage(invalid, this.invalidState),
      new ErrorMessage(doesntExists, this.doesntExistsState),
      new ErrorMessage(alreadyUsed, this.alreadyUsed),
      new ErrorMessage(individualOwnerType, this.individualOwnerType),
      new ErrorMessage(organizationOwnerType, this.organizationOwnerType)
    ];
  }
}
